import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { Payment } from './types/paymentTypes';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Payment'],
  endpoints: (builder) => ({
    getPayments: builder.query<Payment[], void>({
      query: () => 'payments',
      providesTags: ['Payment'],
    }),
    createPayment: builder.mutation<Payment, Record<string, unknown>>({
      query: (body) => ({ url: 'payments', method: 'POST', body }),
      invalidatesTags: ['Payment'],
    }),
    updatePaymentStatus: builder.mutation<Payment, { id: string; status: Payment['status'] }>({
      query: ({ id, status }) => ({
        url: `payments/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: ['Payment'],
    }),
    processRefund: builder.mutation<Payment, { paymentId: string; amount: number; reason: string }>({
      query: (body) => ({ url: 'payments/refund', method: 'POST', body }),
      invalidatesTags: ['Payment'],
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useCreatePaymentMutation,
  useUpdatePaymentStatusMutation,
  useProcessRefundMutation,
} = paymentApi;

export type { Payment };
